{
  "appName": "Authorize VA to Disclose Personal Information to a Third Party for Education Benefits",
  "entryFile": "./app-entry.jsx",
  "entryName": "10278-edu-benefits",
  "rootUrl": "/education/disclose-information-to-third-party/authorize-disclosure-form-22-10278",
  "productId": "67338352-0c30-4eaf-9392-1a5da78d51c8"
}
